/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/

import { LazyModal } from '@freelancer/ui/modal';

export const uiModals: { [k: string]: LazyModal } = {
  CameraModal: {
    loadComponent: () =>
      import('@freelancer/ui/camera-modal/camera-modal.component').then(
        m => m.CameraModalComponent,
      ),
    loadModule: () =>
      import('@freelancer/ui/camera-modal/camera-modal.module').then(
        m => m.CameraModalModule,
      ),
  },
};
